import { render, staticRenderFns } from "./TaskViewActionsDispatcher.vue?vue&type=template&id=9b2a73ca&scoped=true&lang=pug&"
import script from "./TaskViewActionsDispatcher.vue?vue&type=script&lang=js&"
export * from "./TaskViewActionsDispatcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2a73ca",
  null
  
)

export default component.exports